/* eslint @typescript-eslint/camelcase: 0 */

import { VueGtag } from 'vue-gtag';
import Vue from 'vue';
import { AnalyticsEventCategory, AnalyticsEventName } from './analytics.contract';
class AnalyticsEventService {
  public trackEvent(eventName: AnalyticsEventName, category: AnalyticsEventCategory, label: string, value?: number) {
    this.gtagInstance.event(eventName, {
      event_category: category,
      event_label: label,
      value: value,
    });

    const customEventName = `${eventName}_${label}`.replace(/\s+/g, '-');
    this.gtagInstance.event(customEventName, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }

  public trackSearchResult(query: string, resultCount: number) {
    const resultEventName = `sr_${query}_${resultCount}`.replace(/\s+/g, '-');
    this.gtagInstance.event(resultEventName, {
      event_category: AnalyticsEventCategory.Search,
      event_label: query,
      value: resultCount,
    });  }

  private get gtagInstance() {
    return ((Vue as unknown) as any).$gtag as VueGtag;
  }
}
export const analyticsEventService = new AnalyticsEventService();
